import { forwardRef } from '@chakra-ui/react';

import Text, { type TextProps } from '../../../Text';

const Description = forwardRef<TextProps, 'p'>((props, ref) => (
  <Text ref={ref} size="sm" variant="light" {...props} />
));

export default Description;
